import React from "react";
import Page from "../../components/page/Page";
import PageHeader from "../../features/page-header/PageHeader";

export const Settings: React.FC = () => {
    const title = "Settings";

    return (
        <Page
            type="form"
            title={title}
            description={undefined}
            hasBreadcrumbs={true}
            actions={null}
        >
            <PageHeader />
        </Page>
    );
};
